import * as angular from 'angular';

angular
    .module('ib-new-seat-map-module')
    .directive('ibNewFlightMap', ibNewFlightMap);

ibNewFlightMap.$inject = ['$window', '$rootScope', 'localStorageService'];

function ibNewFlightMap ($window: angular.IWindowService, $rootScope: CommonsRootScope, localStorageService: any): angular.IDirective {
    return {
        restrict: 'A',
        transclude: false,
        bindToController: true,
        scope: {
            seatsModel: '=',
            currentPassenger: '=',
            templateUrl: '@',
            passengers: '<',
            aircraftCode: '<',
            seatViewInfo: '<',
            isOldConfig: '<'
        },
        templateUrl: function (element: angular.IAugmentedJQuery, attrs: angular.IAttributes) {
            return attrs.templateUrl || $rootScope.routes.templates + 'ib-modal-new-seats-map-infinite-scroll.html';
        },
        controller: 'ibNewFlightMapController',
        controllerAs: 'mapSeats',
        link: link
    };
}

function link ($scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) {
    /* Tooltip Map*/

    /* Resize responsive tooltip */
    angular.element(this.$window).bind('resize', () => {
        const $tooltip = angular.element('.ib-map-tooltip');
        if ($tooltip.css('display') === 'block') {
            $tooltip.css('display', 'none');
        }
    });

    /* Document click, close tooltip */
    angular.element(this.$window).bind('click', (e) => {
        // Variables
        const $tooltip = angular.element('.ib-map-tooltip'),
            $map = angular.element('.ib-map');
        const $tooltipTouch = angular.element('#toolTipTouch');

        const $target = angular.element(e.target),
            $eventTooltip = $target.closest('.ib-map-tooltip'),
            $eventSeat = $target.closest('.ib-map__column'),
            $eventGap = $target.closest('.ib-map__column--gap');

        const $eventTooltipTouch = $target.closest('.ib-map-tooltip-touch');

        if ((!$eventTooltip || $eventTooltip.length === 0) && (!$eventSeat || $eventSeat.length === 0)) {
            if ($tooltip.css('display') === 'block') {
                $tooltip.css('display', 'none');
            }
        }

        if ((!$eventTooltipTouch || $eventTooltipTouch.length === 0) && (!$eventSeat || $eventSeat.length === 0)) {
            if ($tooltipTouch.css('display') === 'block') {
                angular.element('#toolTipTouch').remove();
            }
        }

        if ($eventGap && $eventGap.length > 0) {
            if ($tooltip.css('display') === 'block') {
                $tooltip.css('display', 'none');
            }
        }
    });
}